// extracted by mini-css-extract-plugin
export var columnList = "_bo-0";